const REASON_SUB_DIRECTORY = "/reason";

export const getEventReasons = `${REASON_SUB_DIRECTORY}/getEventReasons`;
